import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  transform(value: any, limit: number = 20, ellipsis: string = '...'): string {
    if (typeof value !== 'string') {
      return '';
    }

    limit = Math.max(0, limit); // Evita límites negativos

    if (value.length <= limit) {
      return value;
    }

    return value.slice(0, limit) + ellipsis;
  }
}
